import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQAccordion({ items = [], children }) {
  if (!items || items.length === 0) return null;
  return (
    <section className="max-w-[900px] mx-auto px-6 py-20" data-testid="faq-section">
      <div className="text-center mb-10">
        <p className="text-[11px] uppercase tracking-[0.4em] text-white/40">Questions</p>
        <h2 className="mt-3 font-display font-black text-3xl md:text-5xl tracking-tighter">
          Frequently asked
        </h2>
      </div>
      <Accordion type="single" collapsible className="border-t border-white/10" data-testid="faq-accordion">
        {items.map((it, idx) => (
          <AccordionItem
            key={idx}
            value={`faq-${idx}`}
            className="border-b border-white/10 px-2"
            data-testid={`faq-item-${idx}`}
          >
            <AccordionTrigger className="font-display font-medium text-base md:text-lg tracking-tight py-5 hover:no-underline" data-testid={`faq-trigger-${idx}`}>
              {it.q}
            </AccordionTrigger>
            <AccordionContent className="text-white/65 text-sm md:text-base leading-relaxed pb-5 max-w-2xl" data-testid={`faq-content-${idx}`}>
              {it.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      {children && <div className="mt-12">{children}</div>}
    </section>
  );
}
